import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoggedInGuard } from './_guards/logged-in.guard';
import { TutorialsListComponent } from './modals/tutorials-list/tutorials-list.component';
import { TutorialDetailsComponent } from './modals/tutorial-details/tutorial-details.component';
import { AddTutorialComponent } from './modals/add-tutorial/add-tutorial.component';
import { EditTutorialComponent } from './modals/edit-tutorial/edit-tutorial.component';
import { AddWinnersCompetitionComponent } from './modals/add-winners-competition/add-winners-competition.component';
import { NetworkComponent } from './pages/network/network.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [LoggedInGuard],
  },
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule) },
  // { path: 'competitions', component: TutorialsListComponent, canActivate: [LoggedInGuard], },
  // { path: 'network', component: NetworkComponent, canActivate: [LoggedInGuard], },
  // { path: 'competitions/:id', component: TutorialDetailsComponent, canActivate: [LoggedInGuard] },
  // { path: 'add', component: AddTutorialComponent , canActivate: [LoggedInGuard]},
  // { path: 'edit-tutorial/:id', component: EditTutorialComponent , canActivate: [LoggedInGuard]},
  // { path: 'add-winners-competition/:id', component: AddWinnersCompetitionComponent , canActivate: [LoggedInGuard]},
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {} 
